// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /event/player-game-log-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeEventPlayerGameLogGetBody,
  typeEventPlayerGameLogGetOutput200,
} from "../../sdk/event/postEventPlayerGameLogGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildEventPlayerGameLogGetQueryKey(
  payload: typeEventPlayerGameLogGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`playerId:${JSON.stringify(payload.playerId)}`);
  queryKeySegments.push(`teamId:${JSON.stringify(payload.teamId)}`);
  queryKeySegments.push(`seasonId:${JSON.stringify(payload.seasonId)}`);
  queryKeySegments.push(`timeZone:${JSON.stringify(payload.timeZone)}`);
  return [
    "post:event:eventPlayerGameLogGet",
    "svc:events-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeEventPlayerGameLogGetOutput200,
    unknown,
    typeEventPlayerGameLogGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useEventPlayerGameLogGet(
  payload: typeEventPlayerGameLogGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildEventPlayerGameLogGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postEventPlayerGameLogGet(payload),
    ...resolvedOptions,
  });
}
